import { render, staticRenderFns } from "./SimpleTable.vue?vue&type=template&id=78ce4bc2&scoped=true&"
import script from "./SimpleTable.vue?vue&type=script&lang=ts&"
export * from "./SimpleTable.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleTable.vue?vue&type=style&index=0&id=78ce4bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ce4bc2",
  null
  
)

export default component.exports